/**
 * plugins/webfontloader.ts
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */


// @ts-ignore
import WebFont from 'webfontloader';
export function loadFonts () {
    WebFont.load({
        google: {
            families: [
                'Geometria Narrow Regular',
                'Geometria Narrow Medium',
                'Geometria Narrow Bold'
            ]
        }
    });
}
